import { apiFetch } from "./client.js";

export interface TickerInfo {
  symbol: string;
  displayName: string;
  micCode: string;
  sortOrder: number;
  gammaCached: boolean;
}

export interface TickersPayload {
  tickers: TickerInfo[];
  rateLimitReached: boolean;
}

export async function fetchTickers(): Promise<TickersPayload> {
  return apiFetch<TickersPayload>("/api/tickers");
}
